/**
 * Replaces tokens in the provided string with corresponding values from the replacements map, if they exist.
 * @param string - The  string containing tokens in the format {token}.
 * @param titleCase - Should I title-case the text?.
 * @param tokenMap - Map of token strings to configured text pulled in from BaseController.
 * @returns The processed string with tokens replaced.
 */
//TODO: Find a way to refactor this so it can fetch the tokenMap from inside the function instead of needing it passed in.
export function tokenReplace(string, titleCase, tokenMap) {
    if (!string) {
        return null;
    }
    function replaceTokens(stringToReplace) {
        if (!tokenMap) {
            return stringToReplace;
        }
        // Replace tokens in the template string with corresponding values from the token map.
        let result = stringToReplace.replace(/\{(\w+)\}/g, (stringInQuestion, token) => {
            if (tokenMap.has(token)) {
                // Get the replacement value
                let replacement = tokenMap.get(token);
                if (replacement && titleCase) {
                    replacement = replacement.replace(/\w\S*/g, (txt) => {
                        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
                    });
                }
                return replacement;
            }
            else {
                // If the token is not found in the replacements map, return the original string
                return stringInQuestion;
            }
        });
        return result;
    }
    return replaceTokens(string);
}
export function recursiveTokenFilter(obj, titleCase, tokenMap) {
    // Loop through each key in the object
    Object.entries(obj).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            // If the value is an object, recursively traverse
            recursiveTokenFilter(value, titleCase, tokenMap);
        }
        else {
            // Otherwise, run token replacer
            if (typeof value == "string") {
                obj[key] = tokenReplace(value, titleCase, tokenMap);
            }
        }
    });
    return obj;
}
